import type { Editor } from '@tiptap/react';
import { EditorContent } from '@tiptap/react';
import { cn } from '@simplywallst/ui-core/next';
import { richTextClasses } from './editorStyles';

interface Props {
  editor: Editor;
}

export const editorBaseClasses = cn(richTextClasses, [
  'w-full',
  'h-full',
  '[&_.ProseMirror]:h-full',
  '[&_.ProseMirror>*]:first:mt-0',
  '[&_.is-editor-empty]:before:absolute',
  '[&_.is-editor-empty]:before:text-softer',
  '[&_.is-editor-empty]:before:float-left',
  '[&_.is-editor-empty]:before:pointer-events-none',
  '[&_.is-editor-empty]:before:content-[attr(data-placeholder)]',
]);

export const RichTextEditorInput = ({ editor }: Props) => (
  <EditorContent
    className={editorBaseClasses}
    editor={editor}
    data-testid="rich-text-editor-input"
  />
);
